var React = require('react');

function Tick (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"50","cy":"50","r":"50","fill":"white","key":0}),React.createElement("circle",{"cx":"50","cy":"50","r":"50","fill":"currentColor","fillOpacity":"0.25","key":1}),React.createElement("path",{"d":"M71.102 42.301L49.2 65.899C48.0984 67.0982 46.5008 67.7974 44.8016 67.7974C43.1024 67.7974 41.6024 67.0982 40.4032 65.899L28.8992 53.399C26.7 51.0006 26.7976 47.1998 29.2 44.899C31.5984 42.6998 35.3992 42.7974 37.7 45.1998L44.8992 52.899L62.3992 34.001C64.7 31.6026 68.3992 31.501 70.8992 33.7002C73.2 36.1025 73.3989 39.8986 71.102 42.301Z","fill":"currentColor","key":2})]);
}

Tick.defaultProps = {"viewBox":"0 0 100 100","fill":"none"};

module.exports = Tick;

Tick.default = Tick;
